// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.K9IWPbah93zAInlhA9uH{display:flex;align-items:center;justify-content:flex-start;padding:0 44px;overflow-y:auto;overflow-x:hidden}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/rcs/ui/RcsPage/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,kBAAA,CACA,0BAAA,CACA,cAAA,CACA,eAAA,CACA,iBAAA","sourcesContent":[".page {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 0 44px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `K9IWPbah93zAInlhA9uH`
};
export default ___CSS_LOADER_EXPORT___;
